import { apiRequest } from './apiClient';

export const resolveAgrochainLink = (body) =>
  apiRequest('/auth/agrochain/resolve', {
    method: 'POST',
    body,
  });

export const connectCurrentAgrochainLink = (body) =>
  apiRequest('/auth/agrochain/connect-current', {
    method: 'POST',
    auth: true,
    body,
  });

export const provisionAgrochainAccount = (body) =>
  apiRequest('/auth/agrochain/provision', {
    method: 'POST',
    body,
  });
